<template>
  <div class="create-card-group">
    <div @click="doSomething(raid)"
         v-for="(raid, index) in showData"
         :key="index">
      <el-tooltip placement="bottom">
        <div slot="content" class="tooltip-content data-disk">{{ raid.description }}</div>
        <el-card class="deviceType cps-raid-card"
                 :class="{'selected-device-card': myTypeId === raid.raidTypeId}">
          <div slot="header"
               class="clear-fix"
               :class="{'active-card': myTypeId === raid.raidTypeId}">
            <span>
              {{ getDataDiskCardTitle(raid.raidType, raid.deviceType) }}
            </span>
          </div>
          <div class="card-content">{{ raid.volumeDetail }}</div>
        </el-card>
      </el-tooltip>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardGroup',
  props: {
    showData: { // 展示该机型支持的raid类型
      type: Array,
      default: () => []
    },
    chooseTypeId: { // 当前选中raid类型Id
      type: String,
      default: ''
    }
  },
  data() {
    return {
      myTypeId: this.chooseTypeId // 当前选中raid类型Id
    };
  },
  methods: {
    doSomething(raid) {
      this.myTypeId = raid.raidTypeId;
      this.$emit('getType', raid);
    },
    /**
     * 根据raid类型和机型返回展示名称
     * @param raidType
     * @param deviceType
     * @return {*}
     */
    getDataDiskCardTitle(raidType, deviceType) {
      if (raidType === 'RAID51H') {
        if (deviceType === 'cps.c.perf3') {
          return 'RAID 5+1 hotspare';
        } if (deviceType === 'cps.s.perf1') {
          return 'RAID 5+1 hotspare+NO RAID';
        }
      } else {
        return raidType;
      }
    }
  }
};
</script>

<style lang="scss">
  @import "cardGroup";
</style>



// WEBPACK FOOTER //
// src/components/privateNetInstance/create/subs/CardGroup.vue